export default {
  title: 'Настройки',

  errors: {
    componentNotFound: 'Компонент для ключа <b>{key}</b> не найден.'
  }
}
